import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "What I loved about Reactathon 2019",
  "description": "",
  "published": "2019-04-01T00:00:00.000Z",
  "redirect_from": ["/blog/what-i-loved-about-reactathon-2019/swizec/8998"],
  "categories": "Learning, Personal, Travel + Events",
  "hero": "./img/techletter.app-screenshot-1554137660270.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Reactathon was wonderful ❤️ Thanks to all the wonderful speakers. They did a phenomenal job 👌`}</p>
    <p>{`Here's a recap of stuff I learned 👇`}</p>
    <p>{`My experience lasted the full 4 days.`}</p>
    <h2 {...{
      "id": "my-contribution--workshops"
    }}>{`My contribution 👉 workshops`}</h2>
    <blockquote {...{
      "className": "instagram-media",
      "data-instgrm-captioned": "",
      "data-instgrm-permalink": "https://www.instagram.com/p/BvkHoBOlM0h/?utm_source=ig_embed&utm_campaign=loading",
      "data-instgrm-version": "13",
      "style": {
        "background": "#FFF",
        "border": "0",
        "borderRadius": "3px",
        "boxShadow": "0 0 1px 0 rgba(0,0,0,0.5),0 1px 10px 0 rgba(0,0,0,0.15)",
        "margin": "1px",
        "maxWidth": "658px",
        "minWidth": "326px",
        "padding": "0",
        "width": "calc(100% - 2px)"
      }
    }}><div parentName="blockquote" {...{
        "style": {
          "padding": "16px"
        }
      }}>{` `}<a parentName="div" {...{
          "href": "https://www.instagram.com/p/BvkHoBOlM0h/?utm_source=ig_embed&utm_campaign=loading",
          "style": {
            "background": "#FFFFFF",
            "lineHeight": "0",
            "padding": "0 0",
            "textAlign": "center",
            "textDecoration": "none",
            "width": "100%"
          },
          "target": "_blank"
        }}>{` `}<div parentName="a" {...{
            "style": {
              "display": "flex",
              "flexDirection": "row",
              "alignItems": "center"
            }
          }}>{` `}<div parentName="div" {...{
              "style": {
                "backgroundColor": "#F4F4F4",
                "borderRadius": "50%",
                "flexGrow": "0",
                "height": "40px",
                "marginRight": "14px",
                "width": "40px"
              }
            }}></div>{` `}<div parentName="div" {...{
              "style": {
                "display": "flex",
                "flexDirection": "column",
                "flexGrow": "1",
                "justifyContent": "center"
              }
            }}>{` `}<div parentName="div" {...{
                "style": {
                  "backgroundColor": "#F4F4F4",
                  "borderRadius": "4px",
                  "flexGrow": "0",
                  "height": "14px",
                  "marginBottom": "6px",
                  "width": "100px"
                }
              }}></div>{` `}<div parentName="div" {...{
                "style": {
                  "backgroundColor": "#F4F4F4",
                  "borderRadius": "4px",
                  "flexGrow": "0",
                  "height": "14px",
                  "width": "60px"
                }
              }}></div></div></div><div parentName="a" {...{
            "style": {
              "padding": "19% 0"
            }
          }}></div>{` `}<div parentName="a" {...{
            "style": {
              "display": "block",
              "height": "50px",
              "margin": "0 auto 12px",
              "width": "50px"
            }
          }}><svg parentName="div" {...{
              "width": "50px",
              "height": "50px",
              "viewBox": "0 0 60 60",
              "version": "1.1",
              "xmlns": "https://www.w3.org/2000/svg",
              "xmlnsXLink": "https://www.w3.org/1999/xlink"
            }}><g parentName="svg" {...{
                "stroke": "none",
                "strokeWidth": "1",
                "fill": "none",
                "fillRule": "evenodd"
              }}><g parentName="g" {...{
                  "transform": "translate(-511.000000, -20.000000)",
                  "fill": "#000000"
                }}><g parentName="g"><path parentName="g" {...{
                      "d": "M556.869,30.41 C554.814,30.41 553.148,32.076 553.148,34.131 C553.148,36.186 554.814,37.852 556.869,37.852 C558.924,37.852 560.59,36.186 560.59,34.131 C560.59,32.076 558.924,30.41 556.869,30.41 M541,60.657 C535.114,60.657 530.342,55.887 530.342,50 C530.342,44.114 535.114,39.342 541,39.342 C546.887,39.342 551.658,44.114 551.658,50 C551.658,55.887 546.887,60.657 541,60.657 M541,33.886 C532.1,33.886 524.886,41.1 524.886,50 C524.886,58.899 532.1,66.113 541,66.113 C549.9,66.113 557.115,58.899 557.115,50 C557.115,41.1 549.9,33.886 541,33.886 M565.378,62.101 C565.244,65.022 564.756,66.606 564.346,67.663 C563.803,69.06 563.154,70.057 562.106,71.106 C561.058,72.155 560.06,72.803 558.662,73.347 C557.607,73.757 556.021,74.244 553.102,74.378 C549.944,74.521 548.997,74.552 541,74.552 C533.003,74.552 532.056,74.521 528.898,74.378 C525.979,74.244 524.393,73.757 523.338,73.347 C521.94,72.803 520.942,72.155 519.894,71.106 C518.846,70.057 518.197,69.06 517.654,67.663 C517.244,66.606 516.755,65.022 516.623,62.101 C516.479,58.943 516.448,57.996 516.448,50 C516.448,42.003 516.479,41.056 516.623,37.899 C516.755,34.978 517.244,33.391 517.654,32.338 C518.197,30.938 518.846,29.942 519.894,28.894 C520.942,27.846 521.94,27.196 523.338,26.654 C524.393,26.244 525.979,25.756 528.898,25.623 C532.057,25.479 533.004,25.448 541,25.448 C548.997,25.448 549.943,25.479 553.102,25.623 C556.021,25.756 557.607,26.244 558.662,26.654 C560.06,27.196 561.058,27.846 562.106,28.894 C563.154,29.942 563.803,30.938 564.346,32.338 C564.756,33.391 565.244,34.978 565.378,37.899 C565.522,41.056 565.552,42.003 565.552,50 C565.552,57.996 565.522,58.943 565.378,62.101 M570.82,37.631 C570.674,34.438 570.167,32.258 569.425,30.349 C568.659,28.377 567.633,26.702 565.965,25.035 C564.297,23.368 562.623,22.342 560.652,21.575 C558.743,20.834 556.562,20.326 553.369,20.18 C550.169,20.033 549.148,20 541,20 C532.853,20 531.831,20.033 528.631,20.18 C525.438,20.326 523.257,20.834 521.349,21.575 C519.376,22.342 517.703,23.368 516.035,25.035 C514.368,26.702 513.342,28.377 512.574,30.349 C511.834,32.258 511.326,34.438 511.181,37.631 C511.035,40.831 511,41.851 511,50 C511,58.147 511.035,59.17 511.181,62.369 C511.326,65.562 511.834,67.743 512.574,69.651 C513.342,71.625 514.368,73.296 516.035,74.965 C517.703,76.634 519.376,77.658 521.349,78.425 C523.257,79.167 525.438,79.673 528.631,79.82 C531.831,79.965 532.853,80.001 541,80.001 C549.148,80.001 550.169,79.965 553.369,79.82 C556.562,79.673 558.743,79.167 560.652,78.425 C562.623,77.658 564.297,76.634 565.965,74.965 C567.633,73.296 568.659,71.625 569.425,69.651 C570.167,67.743 570.674,65.562 570.82,62.369 C570.966,59.17 571,58.147 571,50 C571,41.851 570.966,40.831 570.82,37.631"
                    }}></path></g></g></g></svg></div><div parentName="a" {...{
            "style": {
              "paddingTop": "8px"
            }
          }}>{` `}<div parentName="div" {...{
              "style": {
                "color": "#3897f0",
                "fontFamily": "Arial,sans-serif",
                "fontSize": "14px",
                "fontStyle": "normal",
                "fontWeight": "550",
                "lineHeight": "18px"
              }
            }}>{` View this post on Instagram`}</div></div><div parentName="a" {...{
            "style": {
              "padding": "12.5% 0"
            }
          }}></div>{` `}<div parentName="a" {...{
            "style": {
              "display": "flex",
              "flexDirection": "row",
              "marginBottom": "14px",
              "alignItems": "center"
            }
          }}><div parentName="div">{` `}<div parentName="div" {...{
                "style": {
                  "backgroundColor": "#F4F4F4",
                  "borderRadius": "50%",
                  "height": "12.5px",
                  "width": "12.5px",
                  "transform": "translateX(0px) translateY(7px)"
                }
              }}></div>{` `}<div parentName="div" {...{
                "style": {
                  "backgroundColor": "#F4F4F4",
                  "height": "12.5px",
                  "transform": "rotate(-45deg) translateX(3px) translateY(1px)",
                  "width": "12.5px",
                  "flexGrow": "0",
                  "marginRight": "14px",
                  "marginLeft": "2px"
                }
              }}></div>{` `}<div parentName="div" {...{
                "style": {
                  "backgroundColor": "#F4F4F4",
                  "borderRadius": "50%",
                  "height": "12.5px",
                  "width": "12.5px",
                  "transform": "translateX(9px) translateY(-18px)"
                }
              }}></div></div><div parentName="div" {...{
              "style": {
                "marginLeft": "8px"
              }
            }}>{` `}<div parentName="div" {...{
                "style": {
                  "backgroundColor": "#F4F4F4",
                  "borderRadius": "50%",
                  "flexGrow": "0",
                  "height": "20px",
                  "width": "20px"
                }
              }}></div>{` `}<div parentName="div" {...{
                "style": {
                  "width": "0",
                  "height": "0",
                  "borderTop": "2px solid transparent",
                  "borderLeft": "6px solid #f4f4f4",
                  "borderBottom": "2px solid transparent",
                  "transform": "translateX(16px) translateY(-4px) rotate(30deg)"
                }
              }}></div></div><div parentName="div" {...{
              "style": {
                "marginLeft": "auto"
              }
            }}>{` `}<div parentName="div" {...{
                "style": {
                  "width": "0px",
                  "borderTop": "8px solid #F4F4F4",
                  "borderRight": "8px solid transparent",
                  "transform": "translateY(16px)"
                }
              }}></div>{` `}<div parentName="div" {...{
                "style": {
                  "backgroundColor": "#F4F4F4",
                  "flexGrow": "0",
                  "height": "12px",
                  "width": "16px",
                  "transform": "translateY(-4px)"
                }
              }}></div>{` `}<div parentName="div" {...{
                "style": {
                  "width": "0",
                  "height": "0",
                  "borderTop": "8px solid #F4F4F4",
                  "borderLeft": "8px solid transparent",
                  "transform": "translateY(-4px) translateX(8px)"
                }
              }}></div></div></div>{` `}<div parentName="a" {...{
            "style": {
              "display": "flex",
              "flexDirection": "column",
              "flexGrow": "1",
              "justifyContent": "center",
              "marginBottom": "24px"
            }
          }}>{` `}<div parentName="div" {...{
              "style": {
                "backgroundColor": "#F4F4F4",
                "borderRadius": "4px",
                "flexGrow": "0",
                "height": "14px",
                "marginBottom": "6px",
                "width": "224px"
              }
            }}></div>{` `}<div parentName="div" {...{
              "style": {
                "backgroundColor": "#F4F4F4",
                "borderRadius": "4px",
                "flexGrow": "0",
                "height": "14px",
                "width": "144px"
              }
            }}></div></div></a><p parentName="div" {...{
          "style": {
            "color": "#c9c8cd",
            "fontFamily": "Arial,sans-serif",
            "fontSize": "14px",
            "lineHeight": "17px",
            "marginBottom": "0",
            "marginTop": "8px",
            "overflow": "hidden",
            "padding": "8px 0 7px",
            "textAlign": "center",
            "textOverflow": "ellipsis",
            "whiteSpace": "nowrap"
          }
        }}><a parentName="p" {...{
            "href": "https://www.instagram.com/p/BvkHoBOlM0h/?utm_source=ig_embed&utm_campaign=loading",
            "style": {
              "color": "#c9c8cd",
              "fontFamily": "Arial,sans-serif",
              "fontSize": "14px",
              "fontStyle": "normal",
              "fontWeight": "normal",
              "lineHeight": "17px",
              "textDecoration": "none"
            },
            "target": "_blank"
          }}>{`A post shared by Swizec Teller (@swizec)`}</a></p></div></blockquote>
    <p>{`React for Data Visualization workshop on Thursday. 7 hours of presenting. Went great, a little rusty coz I haven't done it in a while.`}</p>
    <p>{`Modern Web App with Gatsby, GraphQL, Serverless, and Hooks on Friday. Woke up at 2am to "finish" preparing by 10am, then right into 7 hours of presenting. I was … tired? Dead? Thank god I run marathons otherwise there's no way I'd survive that 😅`}</p>
    <blockquote {...{
      "className": "instagram-media",
      "data-instgrm-captioned": "",
      "data-instgrm-permalink": "https://www.instagram.com/p/BvmxcAdF_LE/?utm_source=ig_embed&utm_campaign=loading",
      "data-instgrm-version": "13",
      "style": {
        "background": "#FFF",
        "border": "0",
        "borderRadius": "3px",
        "boxShadow": "0 0 1px 0 rgba(0,0,0,0.5),0 1px 10px 0 rgba(0,0,0,0.15)",
        "margin": "1px",
        "maxWidth": "658px",
        "minWidth": "326px",
        "padding": "0",
        "width": "calc(100% - 2px)"
      }
    }}><div parentName="blockquote" {...{
        "style": {
          "padding": "16px"
        }
      }}>{` `}<a parentName="div" {...{
          "href": "https://www.instagram.com/p/BvmxcAdF_LE/?utm_source=ig_embed&utm_campaign=loading",
          "style": {
            "background": "#FFFFFF",
            "lineHeight": "0",
            "padding": "0 0",
            "textAlign": "center",
            "textDecoration": "none",
            "width": "100%"
          },
          "target": "_blank"
        }}>{` `}<div parentName="a" {...{
            "style": {
              "display": "flex",
              "flexDirection": "row",
              "alignItems": "center"
            }
          }}>{` `}<div parentName="div" {...{
              "style": {
                "backgroundColor": "#F4F4F4",
                "borderRadius": "50%",
                "flexGrow": "0",
                "height": "40px",
                "marginRight": "14px",
                "width": "40px"
              }
            }}></div>{` `}<div parentName="div" {...{
              "style": {
                "display": "flex",
                "flexDirection": "column",
                "flexGrow": "1",
                "justifyContent": "center"
              }
            }}>{` `}<div parentName="div" {...{
                "style": {
                  "backgroundColor": "#F4F4F4",
                  "borderRadius": "4px",
                  "flexGrow": "0",
                  "height": "14px",
                  "marginBottom": "6px",
                  "width": "100px"
                }
              }}></div>{` `}<div parentName="div" {...{
                "style": {
                  "backgroundColor": "#F4F4F4",
                  "borderRadius": "4px",
                  "flexGrow": "0",
                  "height": "14px",
                  "width": "60px"
                }
              }}></div></div></div><div parentName="a" {...{
            "style": {
              "padding": "19% 0"
            }
          }}></div>{` `}<div parentName="a" {...{
            "style": {
              "display": "block",
              "height": "50px",
              "margin": "0 auto 12px",
              "width": "50px"
            }
          }}><svg parentName="div" {...{
              "width": "50px",
              "height": "50px",
              "viewBox": "0 0 60 60",
              "version": "1.1",
              "xmlns": "https://www.w3.org/2000/svg",
              "xmlnsXLink": "https://www.w3.org/1999/xlink"
            }}><g parentName="svg" {...{
                "stroke": "none",
                "strokeWidth": "1",
                "fill": "none",
                "fillRule": "evenodd"
              }}><g parentName="g" {...{
                  "transform": "translate(-511.000000, -20.000000)",
                  "fill": "#000000"
                }}><g parentName="g"><path parentName="g" {...{
                      "d": "M556.869,30.41 C554.814,30.41 553.148,32.076 553.148,34.131 C553.148,36.186 554.814,37.852 556.869,37.852 C558.924,37.852 560.59,36.186 560.59,34.131 C560.59,32.076 558.924,30.41 556.869,30.41 M541,60.657 C535.114,60.657 530.342,55.887 530.342,50 C530.342,44.114 535.114,39.342 541,39.342 C546.887,39.342 551.658,44.114 551.658,50 C551.658,55.887 546.887,60.657 541,60.657 M541,33.886 C532.1,33.886 524.886,41.1 524.886,50 C524.886,58.899 532.1,66.113 541,66.113 C549.9,66.113 557.115,58.899 557.115,50 C557.115,41.1 549.9,33.886 541,33.886 M565.378,62.101 C565.244,65.022 564.756,66.606 564.346,67.663 C563.803,69.06 563.154,70.057 562.106,71.106 C561.058,72.155 560.06,72.803 558.662,73.347 C557.607,73.757 556.021,74.244 553.102,74.378 C549.944,74.521 548.997,74.552 541,74.552 C533.003,74.552 532.056,74.521 528.898,74.378 C525.979,74.244 524.393,73.757 523.338,73.347 C521.94,72.803 520.942,72.155 519.894,71.106 C518.846,70.057 518.197,69.06 517.654,67.663 C517.244,66.606 516.755,65.022 516.623,62.101 C516.479,58.943 516.448,57.996 516.448,50 C516.448,42.003 516.479,41.056 516.623,37.899 C516.755,34.978 517.244,33.391 517.654,32.338 C518.197,30.938 518.846,29.942 519.894,28.894 C520.942,27.846 521.94,27.196 523.338,26.654 C524.393,26.244 525.979,25.756 528.898,25.623 C532.057,25.479 533.004,25.448 541,25.448 C548.997,25.448 549.943,25.479 553.102,25.623 C556.021,25.756 557.607,26.244 558.662,26.654 C560.06,27.196 561.058,27.846 562.106,28.894 C563.154,29.942 563.803,30.938 564.346,32.338 C564.756,33.391 565.244,34.978 565.378,37.899 C565.522,41.056 565.552,42.003 565.552,50 C565.552,57.996 565.522,58.943 565.378,62.101 M570.82,37.631 C570.674,34.438 570.167,32.258 569.425,30.349 C568.659,28.377 567.633,26.702 565.965,25.035 C564.297,23.368 562.623,22.342 560.652,21.575 C558.743,20.834 556.562,20.326 553.369,20.18 C550.169,20.033 549.148,20 541,20 C532.853,20 531.831,20.033 528.631,20.18 C525.438,20.326 523.257,20.834 521.349,21.575 C519.376,22.342 517.703,23.368 516.035,25.035 C514.368,26.702 513.342,28.377 512.574,30.349 C511.834,32.258 511.326,34.438 511.181,37.631 C511.035,40.831 511,41.851 511,50 C511,58.147 511.035,59.17 511.181,62.369 C511.326,65.562 511.834,67.743 512.574,69.651 C513.342,71.625 514.368,73.296 516.035,74.965 C517.703,76.634 519.376,77.658 521.349,78.425 C523.257,79.167 525.438,79.673 528.631,79.82 C531.831,79.965 532.853,80.001 541,80.001 C549.148,80.001 550.169,79.965 553.369,79.82 C556.562,79.673 558.743,79.167 560.652,78.425 C562.623,77.658 564.297,76.634 565.965,74.965 C567.633,73.296 568.659,71.625 569.425,69.651 C570.167,67.743 570.674,65.562 570.82,62.369 C570.966,59.17 571,58.147 571,50 C571,41.851 570.966,40.831 570.82,37.631"
                    }}></path></g></g></g></svg></div><div parentName="a" {...{
            "style": {
              "paddingTop": "8px"
            }
          }}>{` `}<div parentName="div" {...{
              "style": {
                "color": "#3897f0",
                "fontFamily": "Arial,sans-serif",
                "fontSize": "14px",
                "fontStyle": "normal",
                "fontWeight": "550",
                "lineHeight": "18px"
              }
            }}>{` View this post on Instagram`}</div></div><div parentName="a" {...{
            "style": {
              "padding": "12.5% 0"
            }
          }}></div>{` `}<div parentName="a" {...{
            "style": {
              "display": "flex",
              "flexDirection": "row",
              "marginBottom": "14px",
              "alignItems": "center"
            }
          }}><div parentName="div">{` `}<div parentName="div" {...{
                "style": {
                  "backgroundColor": "#F4F4F4",
                  "borderRadius": "50%",
                  "height": "12.5px",
                  "width": "12.5px",
                  "transform": "translateX(0px) translateY(7px)"
                }
              }}></div>{` `}<div parentName="div" {...{
                "style": {
                  "backgroundColor": "#F4F4F4",
                  "height": "12.5px",
                  "transform": "rotate(-45deg) translateX(3px) translateY(1px)",
                  "width": "12.5px",
                  "flexGrow": "0",
                  "marginRight": "14px",
                  "marginLeft": "2px"
                }
              }}></div>{` `}<div parentName="div" {...{
                "style": {
                  "backgroundColor": "#F4F4F4",
                  "borderRadius": "50%",
                  "height": "12.5px",
                  "width": "12.5px",
                  "transform": "translateX(9px) translateY(-18px)"
                }
              }}></div></div><div parentName="div" {...{
              "style": {
                "marginLeft": "8px"
              }
            }}>{` `}<div parentName="div" {...{
                "style": {
                  "backgroundColor": "#F4F4F4",
                  "borderRadius": "50%",
                  "flexGrow": "0",
                  "height": "20px",
                  "width": "20px"
                }
              }}></div>{` `}<div parentName="div" {...{
                "style": {
                  "width": "0",
                  "height": "0",
                  "borderTop": "2px solid transparent",
                  "borderLeft": "6px solid #f4f4f4",
                  "borderBottom": "2px solid transparent",
                  "transform": "translateX(16px) translateY(-4px) rotate(30deg)"
                }
              }}></div></div><div parentName="div" {...{
              "style": {
                "marginLeft": "auto"
              }
            }}>{` `}<div parentName="div" {...{
                "style": {
                  "width": "0px",
                  "borderTop": "8px solid #F4F4F4",
                  "borderRight": "8px solid transparent",
                  "transform": "translateY(16px)"
                }
              }}></div>{` `}<div parentName="div" {...{
                "style": {
                  "backgroundColor": "#F4F4F4",
                  "flexGrow": "0",
                  "height": "12px",
                  "width": "16px",
                  "transform": "translateY(-4px)"
                }
              }}></div>{` `}<div parentName="div" {...{
                "style": {
                  "width": "0",
                  "height": "0",
                  "borderTop": "8px solid #F4F4F4",
                  "borderLeft": "8px solid transparent",
                  "transform": "translateY(-4px) translateX(8px)"
                }
              }}></div></div></div>{` `}<div parentName="a" {...{
            "style": {
              "display": "flex",
              "flexDirection": "column",
              "flexGrow": "1",
              "justifyContent": "center",
              "marginBottom": "24px"
            }
          }}>{` `}<div parentName="div" {...{
              "style": {
                "backgroundColor": "#F4F4F4",
                "borderRadius": "4px",
                "flexGrow": "0",
                "height": "14px",
                "marginBottom": "6px",
                "width": "224px"
              }
            }}></div>{` `}<div parentName="div" {...{
              "style": {
                "backgroundColor": "#F4F4F4",
                "borderRadius": "4px",
                "flexGrow": "0",
                "height": "14px",
                "width": "144px"
              }
            }}></div></div></a><p parentName="div" {...{
          "style": {
            "color": "#c9c8cd",
            "fontFamily": "Arial,sans-serif",
            "fontSize": "14px",
            "lineHeight": "17px",
            "marginBottom": "0",
            "marginTop": "8px",
            "overflow": "hidden",
            "padding": "8px 0 7px",
            "textAlign": "center",
            "textOverflow": "ellipsis",
            "whiteSpace": "nowrap"
          }
        }}><a parentName="p" {...{
            "href": "https://www.instagram.com/p/BvmxcAdF_LE/?utm_source=ig_embed&utm_campaign=loading",
            "style": {
              "color": "#c9c8cd",
              "fontFamily": "Arial,sans-serif",
              "fontSize": "14px",
              "fontStyle": "normal",
              "fontWeight": "normal",
              "lineHeight": "17px",
              "textDecoration": "none"
            },
            "target": "_blank"
          }}>{`A post shared by Swizec Teller (@swizec)`}</a></p></div></blockquote>
    <p>{`That one suffered from the First Iteration problem. You could tell the content wasn't polished yet, the flow wasn't quite there. I made some questionable technical decisions in the example project, we spent too long on some sections, too little on some others.`}</p>
    <p>{`But I think people still learned a lot, asked great questions, and we covered a lot of ground. Too much ground. Could easily turn it into a 3 or 4 day workshop.`}</p>
    <p>{`A few more iterations and I think it's gonna be magnificent.`}</p>
    <p><strong parentName="p">{`Lesson learned:`}</strong>{` Don't have 2 workshops on different topics in the same week. So tired 😴`}</p>
    <p>{`This was followed right away by the speaker dinner.`}</p>
    <h2 {...{
      "id": "speaker-dinner"
    }}>{`Speaker dinner`}</h2>
    <p>{`Speaker dinners are amazing. Best part of any conference. It's like getting peer level access to the top minds in your industry.`}</p>
    <p>{`Unless of course you're so tired from being up since 2am and presenting all day that you can barely say Hi.`}</p>
    <p>{`But I chatted dirt bikes with `}<a parentName="p" {...{
        "href": "https://twitter.com/ken_wheeler"
      }}>{`Ken Wheeler`}</a>{` and forgot to take a selfie. It was like meeting a down-to-earth celebrity 🤩`}</p>
    <p>{`And I `}<strong parentName="p">{`learned an important phrase`}</strong>{` from `}<a parentName="p" {...{
        "href": "https://twitter.com/acemarke"
      }}>{`Mark Erikson (@acemarke)`}</a>{`: `}<em parentName="p">{`"My social battery is now running low. Good night"`}</em></p>
    <p>{`👌`}</p>
    <h2 {...{
      "id": "reactathon-day-1--the-lightning-talks"
    }}>{`Reactathon Day 1 – the lightning talks`}</h2>
    <p>{`I love lightning talks.`}</p>
    <p>{`Each of these is a twitter thread with my live notes. Click through. I'm writing here from memory :)`}</p>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/Swizec/status/1112168749212164096"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "480px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "106.72645739910314%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'428\\'%20viewBox=\\'0%200%20400%20428\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M32%2021c-10%205-11%2018-2%2025%205%203%2012%204%2017%201%203-2%203-4-1-4-2%200-3-3-1-5l4-1%202-2h1c2%201%202-3%201-6-3-8-14-12-21-8m31%2085c-2%202-2%202-2%2037v35l6%201c7%201%209%200%209-3s2-2%203%201%202%203%2017%206l9%202c-1%201-1%201%201%201v2l-1%201-1-1h-1l-1%202-4%201-5%201-1%201-2%201H80l-2-1-3-1h-5l-3-1c-1%201-2%200-2-1h-3a2482%202482%200%20001%20148c3%203%20307%203%20310%200%202-1%202-3%202-13l1-12-6-1-6-1h4c7%200%208%200%207-2v-9c0-7%200-8-2-8v-1c2-1%203-30%201-30v-1l2-4v-3l-79%201-85-1h-5l4-2%202-1c-2%200-2%200-1-1l1-4%201-5%201-15c1-15%201-15-6-15-6%200-7-2-5-9v-3l6%201h6l2-1%202-2c0-2%200-3%204-3%203-1%203-1-1-1-3-1-4-2-2-3l7-1h5l-5-1h-8v-2c2%200%202-1%201-2s0-3%201-3h6c4%200%204%200%202-1h-8c-6%200-7-2-2-2%2027-4%2028-4%2028-1h1l1-1%201-1%203-2%204-3c3%200%205-3%203-5v-2l3-2%204-2h-20v-2c-1-3%201-4%203-2h1c0-2%201-2%204-2h6l5-1h5a245%20245%200%200137-3c1-2%2013-2%2013-1h1l2-1h11l1%201%201-1%201-2%201%202%201%201%201-1c-1-2%200-2%201-2%203%200%203%204%200%206-2%201%200%204%203%205%202%201%202%201%200%202-4%201-4%202%205%207l8%206%206%206%201%201c-1%201%201%203%203%205l5%205c1%201%201-9%201-21v-23h-3c-2%200-3%200-2-1l3-1h3v-17c0-16-1-16-3-18-4-3-306-3-310%200m81%2078l-1%203h-11c-14-2-16-2-16-1l2%201c2%200%203%201%203%203l2%206c4%202%205%203%2012%203l8%203c1%202%202%202%202%201h4l3-1%204-2c1%200%205-4%205-6l2-2c2-1%202-1-2-1-14-2-14-2-15-5%200-3-1-3-2-2m-38%2024l-2%203c0%202-1%203-4%205s-3%205%201%206c1%201%202%202%201%204%200%204%202%206%206%204h4c2%200%202%200%201-1-1-2%201-4%204-4l7-3-2%201c-2%200-4-1-3-4%200-2%203-1%204%201l2%201-1-3c-2-1-3-4-3-5%200-3-1-3-5-3l-7-2h-3m189%2081l-20%201h-20l13%201c12%200%2013%200%2013%202l-12%201-13-1-3%201c-2%201%206%202%2028%202a286%20286%200%200121-1c1-1%200-1-3-1-4-1-5-2%200-3%202-1%202-1%200-1l-3-1h-1m-39%2012c0%202%200%202-4%202-5%200-3%201%203%201l7%202h1a284%20284%200%200156%200l3-1-12-1-12-1h-2c-1%201-36%201-38-1l-1-2v-1c-1%200-2%201-1%202m30%207c-1%202-1%202%202%202%204%200%206%203%202%204a1258%201258%200%200136%202c4%200%205%201%203%204-1%201%200%201%205%201s5%200%201-1c-3%200-4%200-4-2s1-2%206-2l6-1h-11c-10%200-11%200-11-4h16a480%20480%200%2000-51-3m-169%2070c1%201%200%202-2%202s-3%201-3%203c0%204%202%206%207%207%205%200%208-2%208-6%200-3-3-5-4-3-1%201-1%201-1-2%200-2-1-3-3-3s-2%200-2%202m34%200c-3%203-3%208%200%2010%204%204%209%203%2011-2%204-7-5-14-11-8m18%200c-4%204-2%2010%202%2010%202%200%202%200%201%201s0%201%203%201%203%200%202-1c-2-1-2-1%200-1%203%200%204-1%204-3%203-7-7-12-12-7m55-1c-4%204-3%209%202%2013%206%204%2014-6%208-12-3-2-7-3-10-1m19%201c-2%202-2%203%200%202l1%201-2%201c-2%200-2%201-2%203s1%203%207%203%207-1%207-4l-2-2-2-1h2l1-1c0-2-3-4-6-4l-4%202m17%200c-2%202-2%203-2%206%201%206%204%206%207%200%201-2%201-3%202-2l-3%207%201%201c3%201%208-4%208-7%200-6-9-9-13-5m-53%201c-3%201-4%203-2%207%203%205%204%205%209%204%204-2%204-5%201-7-2-1-2-1-1-2%202-3-3-4-7-2\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/002ece226cffe6ccb8d1bad285ca81b9/ca0a1/techletter.app-screenshot-1554137660270.webp 223w", "/static/002ece226cffe6ccb8d1bad285ca81b9/75680/techletter.app-screenshot-1554137660270.webp 445w", "/static/002ece226cffe6ccb8d1bad285ca81b9/d3be9/techletter.app-screenshot-1554137660270.webp 480w"],
                "sizes": "(max-width: 480px) 100vw, 480px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/002ece226cffe6ccb8d1bad285ca81b9/e92b6/techletter.app-screenshot-1554137660270.png 223w", "/static/002ece226cffe6ccb8d1bad285ca81b9/e66bf/techletter.app-screenshot-1554137660270.png 445w", "/static/002ece226cffe6ccb8d1bad285ca81b9/e85cb/techletter.app-screenshot-1554137660270.png 480w"],
                "sizes": "(max-width: 480px) 100vw, 480px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/002ece226cffe6ccb8d1bad285ca81b9/e85cb/techletter.app-screenshot-1554137660270.png",
                "alt": "https://twitter.com/Swizec/status/1112168749212164096",
                "title": "https://twitter.com/Swizec/status/1112168749212164096",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`https://twitter.com/Swizec/status/1112168749212164096`}</figcaption>{`
  `}</figure></a></p>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/ken_wheeler"
      }}>{`Ken Wheeler`}</a>{` talked about the renderless component pattern and how it applies to hooks. There was some talk about inverting control of children to their parent, which was hard to grasp in a short talk like this.`}</p>
    <p>{`Then he showed us an app he built with react-music and hooks. Gives you a UI to create sick beats and play music. Wonderful.`}</p>
    <p>{`His render-html-to-canvas demo was amazing too. He says he's not ready to share that one until it can be accessible.`}</p>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/Swizec/status/1112171920068239360"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "480px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "60.98654708520179%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'244\\'%20viewBox=\\'0%200%20400%20244\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M29%2023c-4%204-4%204-4%2011l1%207%201%202c0%201%206%205%2010%206%203%200%205%200%208-2%206-2%206-4%202-4l-3-2c0-2%202-4%205-4l2-1%202-1c3%200%200-9-5-13-7-5-14-4-19%201m33%20104c0%206%200%206%203%206%204%200%207-3%207-6%200-5-2-7-7-7h-3v7m133%2015c-4%204-1%2011%204%2011%203%200%206-3%206-6%200-6-6-9-10-5m-35%2052c-3%202-3%209%200%2010h7c4%200%204%200%204-4%200-7-6-10-11-6m54%200c-3%202-3%208-1%2011%203%202%208%203%2011%200%206-7-3-17-10-11m-15%200v2l-2%203c-4%202-4%203-1%206s4%203%204%200l1-2v2c0%203%202%203%204%200%203-2%202-5-1-6l-2-4c0-2-2-3-3-1\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/c49e2a79b601db0629c246d436743a82/ca0a1/techletter.app-screenshot-1554137655312.webp 223w", "/static/c49e2a79b601db0629c246d436743a82/75680/techletter.app-screenshot-1554137655312.webp 445w", "/static/c49e2a79b601db0629c246d436743a82/d3be9/techletter.app-screenshot-1554137655312.webp 480w"],
                "sizes": "(max-width: 480px) 100vw, 480px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/c49e2a79b601db0629c246d436743a82/e92b6/techletter.app-screenshot-1554137655312.png 223w", "/static/c49e2a79b601db0629c246d436743a82/e66bf/techletter.app-screenshot-1554137655312.png 445w", "/static/c49e2a79b601db0629c246d436743a82/e85cb/techletter.app-screenshot-1554137655312.png 480w"],
                "sizes": "(max-width: 480px) 100vw, 480px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/c49e2a79b601db0629c246d436743a82/e85cb/techletter.app-screenshot-1554137655312.png",
                "alt": "https://twitter.com/Swizec/status/1112171920068239360",
                "title": "https://twitter.com/Swizec/status/1112171920068239360",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`https://twitter.com/Swizec/status/1112171920068239360`}</figcaption>{`
  `}</figure></a></p>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/knitcodemonkey"
      }}>{`Jen Luker`}</a>{` gave us a great way to introduce accessibility into our existing apps 👉 create a lint rule, set everything to warning. Change one rule to error.`}</p>
    <p>{`Everyone complains, everyone grumbles, everyone fixes it.`}</p>
    <p>{`Then you set the next rule to error. Repeat until your app is accessible.`}</p>
    <p>{`Did you know 25% of Americans have some form of disability that requires accessible webapps? Imagine how amazing your business could be with 25% higher conversion rates. 😉`}</p>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/Swizec/status/1112175761866145792"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "480px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "71.74887892376681%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'287\\'%20viewBox=\\'0%200%20400%20287\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M31%2021c-9%206-9%2019-1%2025%205%203%2012%204%2017%201%203-2%203-4%200-4l-3-2c0-2%202-4%205-4l2-1%201-1%202-1-4-10-3-2c-3-3-11-4-16-1m78%20216c-4%204-4%2011%201%2010h8l2-2c2-5-2-10-6-10l-5%202m17%201c-3%203-3%207%200%2010%205%204%2013%201%2013-6s-9-10-13-4\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/78d9b420db3ee17c881c5bce2b8a4040/ca0a1/techletter.app-screenshot-1554137659589.webp 223w", "/static/78d9b420db3ee17c881c5bce2b8a4040/75680/techletter.app-screenshot-1554137659589.webp 445w", "/static/78d9b420db3ee17c881c5bce2b8a4040/d3be9/techletter.app-screenshot-1554137659589.webp 480w"],
                "sizes": "(max-width: 480px) 100vw, 480px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/78d9b420db3ee17c881c5bce2b8a4040/e92b6/techletter.app-screenshot-1554137659589.png 223w", "/static/78d9b420db3ee17c881c5bce2b8a4040/e66bf/techletter.app-screenshot-1554137659589.png 445w", "/static/78d9b420db3ee17c881c5bce2b8a4040/e85cb/techletter.app-screenshot-1554137659589.png 480w"],
                "sizes": "(max-width: 480px) 100vw, 480px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/78d9b420db3ee17c881c5bce2b8a4040/e85cb/techletter.app-screenshot-1554137659589.png",
                "alt": "https://twitter.com/Swizec/status/1112175761866145792",
                "title": "https://twitter.com/Swizec/status/1112175761866145792",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`https://twitter.com/Swizec/status/1112175761866145792`}</figcaption>{`
  `}</figure></a></p>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/_jayphelps"
      }}>{`Jay Phelps`}</a>{` talked about Wasm. The main message I got from his talk is that Web Assembly is amazing and getting amazinger with each passing day.`}</p>
    <p>{`It's never going to replace JavaScript and it isn't meant to. It's meant to bring C, Rust, etc. to the frontend for those high-CPU tasks you have to do sometimes.`}</p>
    <p>{`Gives me interesting ideas for data visualization. You know those times when you're processing a dataset with 100,000+ entries and it slows down your whole app? Might be wasm-able.`}</p>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/Swizec/status/1112178754468470785"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "480px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "61.88340807174888%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'247\\'%20viewBox=\\'0%200%20400%20247\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M31%2021c-9%206-9%2019%200%2026%204%203%2011%203%2016%200%203-2%203-4%200-4l-3-1c0-2%202-5%204-5%203%200%206-2%206-4l-4-9-3-2c-3-3-11-4-16-1m34%20123v3c1%201%201%201-1%203l-1%204c1%203%2018%203%2019%200l-2-4c-2-3-3-4%200-3l1-1c0-1-3-4-5-4s-1%202%201%203l-1%201c-3%201-4%203-1%203%201%201%200%201-3%201s-4%200-3-1c4%200%203-2%200-3l-1-1%202-2c0-2-3-1-5%201m44%2053c-4%204-4%2011%201%2010h8l2-2c2-5-2-10-6-10l-5%202m20-1c-3%202-3%202-2%206v3c-2%200-1%203%202%204h7c1-2%201-2-1-3-2-2-3-8%200-9l-1-1h-5\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/ed152cced2de72a34066b08702cbc3e6/ca0a1/techletter.app-screenshot-1554137660529.webp 223w", "/static/ed152cced2de72a34066b08702cbc3e6/75680/techletter.app-screenshot-1554137660529.webp 445w", "/static/ed152cced2de72a34066b08702cbc3e6/d3be9/techletter.app-screenshot-1554137660529.webp 480w"],
                "sizes": "(max-width: 480px) 100vw, 480px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/ed152cced2de72a34066b08702cbc3e6/e92b6/techletter.app-screenshot-1554137660529.png 223w", "/static/ed152cced2de72a34066b08702cbc3e6/e66bf/techletter.app-screenshot-1554137660529.png 445w", "/static/ed152cced2de72a34066b08702cbc3e6/e85cb/techletter.app-screenshot-1554137660529.png 480w"],
                "sizes": "(max-width: 480px) 100vw, 480px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/ed152cced2de72a34066b08702cbc3e6/e85cb/techletter.app-screenshot-1554137660529.png",
                "alt": "https://twitter.com/Swizec/status/1112178754468470785",
                "title": "https://twitter.com/Swizec/status/1112178754468470785",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`https://twitter.com/Swizec/status/1112178754468470785`}</figcaption>{`
  `}</figure></a></p>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/jaredforsyth"
      }}>{`Jared Forsyth`}</a>{` hyped us up about ReasonML and using it for Native React on the desktop. Write your app in Reason instead of Electron and you can compile straight to native code.`}</p>
    <p>{`No more WebKit, no more spinning fans, just smooth performance at a fraction of CPU and memory usage. His demo looked amazing.`}</p>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/Swizec/status/1112181144605188096"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "480px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "108.5201793721973%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'433\\'%20viewBox=\\'0%200%20400%20433\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M29%2023l-5%206%202%2012%201%201c0%202%205%206%2010%206%204%201%209%200%2012-3%201-2%201-2-1-2-4%200-5-3-2-5l3-1%203-2c6-5-4-16-14-16-5%200-6%200-9%204m94%20139c-4%204-2%209%204%2014%204%204%206%204%2011-1%203-4%204-5%204-8%200-5-4-8-8-6h-5c-3-1-4-1-6%201m-61%2028l-2%203v32c0%2035%200%2034%206%2032%203%200%205%202%203%204l1%202v1l-3%202v2c1-1%201%200%201%202%200%201%200%202-1%201%200-3-3-2-5%200-3%203-3%2069%200%2073l1%202h120a4923%204923%200%2000124-3l1-1-2-1h-2c0-1%201-2%203-2s3%202%202%206c0%202%203%201%203-1l1-2v4h29l30-1c2-1%204-12%202-12l-1-2%201-2%201-16v-15h-15l-40%201c-30%200-27%202-25-16l1-13-5-1c-4%200-4%200-4-4s2-4%207-1c7%202%209%202%2014-4%203-4%206-6%207-6l3-1%202-2%202-1%202-2%202-1%201-2%202-1c1%201%201%200%201-1%200-5%202-5%2023-5a946%20946%200%200013%202l1%201%201%201c1-1%205%201%205%203a212%20212%200%20000-55l-3-2H65l-3%202m156%2052v21h-7l-6%201c0%202-2%203-4%201-1-3%201-5%205-5l5-1c3-2%202-2-5-4-4%200-4%200-2-8%201-2-4-3-8-2-2%201-9%207-8%208l-1%201c-3%200-2-5%201-6%201-1%201-1-2-2-6-1-7%202-7%2010%201%206%201%207-1%207-3%200-2%201%201%204%202%202%202%202%200%202-1%201-2%200-2-1l-1-1-2%201-3%204c-3%201-4%202-3%204l15%201h14l3%201h18v6c0%206%201%206%201%200%201-4%203-7%203-3h1l1-2v-1l-1-2%201-2c1%200%202-1%201-3%200-3-1-3-3-3s-2-1-2-8l-1-23-1-16v21m-131-1c0%202-1%202-7%202h-6v1c-2%204%2015%209%2020%206%206-3%206-4%200-5l-5-3c-1-2-1-2-2-1m156%2010c0%202-1%202-8%202-6-1-7-1-7%201-1%202%206%206%2011%207%2014%201%2016%200%2017-4%200-2-1-2-3-2-4%200-8-2-8-4h-2m-103%2015l-1%2014-1%209h16l8-1c-7%200-8-1-5-3%202-2%202-2%201-6v-5c0-3-5-8-9-8l-5-2c-3-3-4-2-4%202m-31%20118c-2%202-3%206-3%208%201%202%2013%202%2014%200%202-4-2-10-6-10l-5%202m17%201c-3%203-3%206%200%207l2%203h6c0-1%201-2%203-2%201%200%202-1%202-4%200-7-9-10-13-4m37-1c-3%202-3%208%200%2010%202%202%209%203%209%201l2-2c2%200%202-6-1-9-2-2-7-3-10%200m36%200c-2%203-3%206-1%206v2c0%202%203%205%207%205%203%200%207-5%207-8%200-6-8-9-13-5m18%200c-3%203-3%207%200%2010l2%201c0-2%200-2%201-1%201%202%204%203%205%201l-1-1h-2c0-2%203-3%204-2l1-1h2c2%201%201-5-1-7-3-3-8-3-11%200m21%200l-2%201-2%202v5l1%202c1%202%205%204%209%202%202-1%202-1%201-2v-11c-2-2-7-1-7%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/7e37a8c5dc4548235c5c8f013e2d9496/ca0a1/techletter.app-screenshot-1554137659550.webp 223w", "/static/7e37a8c5dc4548235c5c8f013e2d9496/75680/techletter.app-screenshot-1554137659550.webp 445w", "/static/7e37a8c5dc4548235c5c8f013e2d9496/d3be9/techletter.app-screenshot-1554137659550.webp 480w"],
                "sizes": "(max-width: 480px) 100vw, 480px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/7e37a8c5dc4548235c5c8f013e2d9496/e92b6/techletter.app-screenshot-1554137659550.png 223w", "/static/7e37a8c5dc4548235c5c8f013e2d9496/e66bf/techletter.app-screenshot-1554137659550.png 445w", "/static/7e37a8c5dc4548235c5c8f013e2d9496/e85cb/techletter.app-screenshot-1554137659550.png 480w"],
                "sizes": "(max-width: 480px) 100vw, 480px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/7e37a8c5dc4548235c5c8f013e2d9496/e85cb/techletter.app-screenshot-1554137659550.png",
                "alt": "https://twitter.com/Swizec/status/1112181144605188096",
                "title": "https://twitter.com/Swizec/status/1112181144605188096",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`https://twitter.com/Swizec/status/1112181144605188096`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Then `}<a parentName="p" {...{
        "href": "https://twitter.com/swyx"
      }}>{`@swyx`}</a>{` showed us how to re-implement hooks in some 23 lines of code. No magic, just JavaScript like we used to write many years ago.`}</p>
    <p>{`Closures of closures within closures. Gives you modules and curried values and all sorts of things.`}</p>
    <p>{`It's too technical to recap here and I'm sure he's going to post slides soon. He always does.`}</p>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/Swizec/status/1112184764717363200"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "480px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "106.72645739910314%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'428\\'%20viewBox=\\'0%200%20400%20428\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M32%2021c-14%207-8%2028%208%2028l7-2%204-2-4-2c-5-2-4-6%202-6l2-1%201-1c2%202%202-3%201-7-4-7-14-11-21-7m32%2085l-3%202v66h20l8%201v6l-1%207a205%20205%200%2001-24-3h-3v76c0%2074%200%2075%202%2077s3%202%20155%202h154l2-3c2-2%202-3%202-42l-1-40h-29c-47%202-169%203-170%203l2-83a922%20922%200%200139-4l4-3c13-2%2010-2-8-1-30%202-35%201-35-1s1-3%204-3l5-2%2015-2a222246%20222246%200%2000132-9l28%201%201%206a1524%201524%200%200012%2072%201184%201184%200%2000-1-123c-2-1-10-2-155-2H66l-2%202m269%2053l-23%202h-3l2%201%203%201%2014-1c17-1%2016%200-2%202l-14%202%2041-2c5%200%205%200%205-3-1-4%201-4-23-2m-218%2029c-1%203-1%203-7%203-7-1-7-1-6%201l1%201%202%202%205%202%205%201h5c1%200%203%200%204-2l3-3h-5c-3-1-4-1-5-4l-1-3-1%202m-42%2024l-2%204-1%202c-3%200-7%204-5%205l2%202v-5c4-2%207%201%205%205-4%205-3%209%201%209%203%200%203%200%201-1-3%200-3-1-3-3%201-3%204-3%206%200l2%202%202-2c4-3%206-3%206%201l-2%203c-2%201-2%201%200%201s3-1%203-3%202-4%203-5l3-1h-3c-2%201-3%201-3-1-1-4%205-5%206-1h1l-2-3c-3-1-3-2-3-5%200-4%200-4-3-4l-4%201-4-1c-4-2-5-2-6%200m93%20166c-2%201-2%201-1%202v2c-2%201-2%202-1%204%202%205%207%207%2012%203%206-7-2-17-10-11m35%201c-2%203-2%204-1%208%204%207%2014%204%2014-4%200-7-9-10-13-4m40-2l-3%204c0%203%201%207%202%206l1%201%202%202c1%200%202%200%201-1l1-2%201%201v1c2%200%203-7%201-9-2-3-4-4-6-3m15%201c-6%207%203%2017%2010%2011%203-2%204-6%201-6v-1c3-1-1-6-6-6l-5%202m18%201c-3%203-3%207%200%2010%205%204%2013%201%2013-6s-9-10-13-4m40-1l-3%201c-1%200-2%201-2%204v4l2-4c1-3%201-3%200%200v4l2%203c4%202%209%200%208-4%200-2%200-2%201-1s1%201%201-2l-1-5h-8\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/62a4189ae348248f4b017c5c7c8a1cf9/ca0a1/techletter.app-screenshot-1554138068654.webp 223w", "/static/62a4189ae348248f4b017c5c7c8a1cf9/75680/techletter.app-screenshot-1554138068654.webp 445w", "/static/62a4189ae348248f4b017c5c7c8a1cf9/d3be9/techletter.app-screenshot-1554138068654.webp 480w"],
                "sizes": "(max-width: 480px) 100vw, 480px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/62a4189ae348248f4b017c5c7c8a1cf9/e92b6/techletter.app-screenshot-1554138068654.png 223w", "/static/62a4189ae348248f4b017c5c7c8a1cf9/e66bf/techletter.app-screenshot-1554138068654.png 445w", "/static/62a4189ae348248f4b017c5c7c8a1cf9/e85cb/techletter.app-screenshot-1554138068654.png 480w"],
                "sizes": "(max-width: 480px) 100vw, 480px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/62a4189ae348248f4b017c5c7c8a1cf9/e85cb/techletter.app-screenshot-1554138068654.png",
                "alt": "https://twitter.com/Swizec/status/1112184764717363200",
                "title": "https://twitter.com/Swizec/status/1112184764717363200",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`https://twitter.com/Swizec/status/1112184764717363200`}</figcaption>{`
  `}</figure></a></p>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/tanmaigo"
      }}>{`Tanmai Gopal`}</a>{` had the best jokes of any lightning talk. So on point, it was beautiful to watch.`}</p>
    <p>{`Amazing demo too. Using GraphQL subscriptions, Hasura backend, and some serverless stuff, he's able to live stream data into and out of webapp `}<em parentName="p">{`and`}</em>{` stay resilient to network failures. The stream just waits and resumes when you come back online. Love it.`}</p>
    <h2 {...{
      "id": "reactathon-day-2--the-full-conf"
    }}>{`Reactathon Day 2 – the full conf`}</h2>
    <p>{`I drank my morning tea scrolling through imgur sitting in my comfy chair at home. So I missed the first keynote.`}</p>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/benmvp"
      }}>{`Ben Ilegbodu`}</a>{` talked about the state of the React ecosystem.`}</p>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/Swizec/status/1112414785214144512"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "480px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "126.90582959641254%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'508\\'%20viewBox=\\'0%200%20400%20508\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M32%2021c-6%203-8%207-8%2014l2%206%201%202%202%202c2%201%202%201%201-4-2-4-2-4%201-4%202%200%203%201%201%203-2%201%200%202%203%202%204%200%207-3%205-4l1-1c4-1%203-1%201%204-3%205-4%206-8%206h-3c2%203%2013%202%2017-1l3-2-4-1c-5-1-4-6%202-6l2-1%202-2c3%200%200-7-6-12-5-4-9-4-15-1m34%20164c-5%202-5-2-5%2067a463%20463%200%20001%2064l-1%2050c0%2049%200%2050%202%2052s3%202%20155%202h154l2-3c2-2%202-3%202-42v-40l-19-1-19-1%202-40%2017%201h18l1-53v-52l-2-3-3-2H219l-153%201m56%2087l-6%201-4%201-1%2022v23h5l-1%2019a211%20211%200%2001-1%2025c2-1%202-1%202%201%200%203%200%203%202%203l2-1v-1l2-3%201-5c-2-11%201-19%207-17%204%201%204%205%202%2010l-4%204c-2%200-3%201-2%203l2%206v5h128l-1-29v-29h-11c-9%200-10%200-10%202s0%202%202%201c5-2%209%204%205%209-1%202-3%203-6%201l-3-1c-2-1-2-2-2-6v-6h-15v-12l-1-12v-10h-9a3936%203936%200%2000-83-4m64%2025c-2%201-2%201%200%201%202-1%204%200%205%201%202%201%202%202%201%202v2l-3-1v-3l-1%201-2%201-1%202c1%201%201%201-2%201-2-1-3-1-3%201l1%203%201-1c-1-2%200-2%202-2l4-1%2011%201h11c1-1-7-7-11-8h-13m-26%20160c-3%202-4%209-2%2011s10%202%2012%200c6-6-4-16-10-11m39%202c-2%202-2%203-1%203%203%200%202%202-1%202h-3c-3%200%200%203%203%205%205%203%208%201%208-4s1-6%202-3l1%203v-3l-4-4-3-2-2%203m33-1c-3%204-3%206-1%209%203%204%205%204%206%200l2-4v4l-1%204c3%200%207-6%206-8-1-4-4-7-7-7l-5%202m25%200l-3%203c-3%201-4%200-4-1h-1c-2%201-1%208%201%208l3%202c3%203%209-2%209-8l-2-4c-3-2-4-2-3%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/b2d4ed1dfd98ff72fa0c7ae984df20ab/ca0a1/techletter.app-screenshot-1554137659757.webp 223w", "/static/b2d4ed1dfd98ff72fa0c7ae984df20ab/75680/techletter.app-screenshot-1554137659757.webp 445w", "/static/b2d4ed1dfd98ff72fa0c7ae984df20ab/d3be9/techletter.app-screenshot-1554137659757.webp 480w"],
                "sizes": "(max-width: 480px) 100vw, 480px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/b2d4ed1dfd98ff72fa0c7ae984df20ab/e92b6/techletter.app-screenshot-1554137659757.png 223w", "/static/b2d4ed1dfd98ff72fa0c7ae984df20ab/e66bf/techletter.app-screenshot-1554137659757.png 445w", "/static/b2d4ed1dfd98ff72fa0c7ae984df20ab/e85cb/techletter.app-screenshot-1554137659757.png 480w"],
                "sizes": "(max-width: 480px) 100vw, 480px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/b2d4ed1dfd98ff72fa0c7ae984df20ab/e85cb/techletter.app-screenshot-1554137659757.png",
                "alt": "https://twitter.com/Swizec/status/1112414785214144512",
                "title": "https://twitter.com/Swizec/status/1112414785214144512",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`https://twitter.com/Swizec/status/1112414785214144512`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Followed by `}<a parentName="p" {...{
        "href": "https://twitter.com/acemarke"
      }}>{`Mark Erikson`}</a>{`'s great talk on the state of Redux. But I missed most of that one because mum wanted to facetime and mums are important.`}</p>
    <p>{`I did stay long enough to learn that 50% of all React apps out there use Redux. That blew my mind. 🤯`}</p>
    <p>{`After fulfilling my Good Son duties I was ready to buckle down, sit through the conference, and not take my laptop out even once. Not once.`}</p>
    <p>{`Sit in front row and be the audience you always wish you had. Take pictures, live tweet, and pay attention. Speakers appreciate that.`}</p>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/Swizec/status/1112428230063984640"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "480px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "102.24215246636771%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'409\\'%20viewBox=\\'0%200%20400%20409\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M31%2021c-5%203-7%208-7%2014l2%206%201%202c0%201%206%205%2010%205%204%201%209%200%2012-3%201-2%201-2-1-2-4%200-5-3-2-5%201-1%203-2%204-1l1-1%201-2c3%201%201-10-3-11l-3-2c-3-3-10-3-15%200m34%20143c-5%202-5%200-5%2079%200%2073%200%2074%202%2076l2%203h307l2-3c3-4%203-149%200-153l-2-2h-98l-4%203c-5%205-4%206%209%2012%208%204%2012%207%2012%208l2%204c1%204%202%2011%200%2011l-1%202-1%201c-1%200-3%205-3%208l3%206%204%203v14l-1%2013-2%202-1%201c0-2-1-2-4-2h-5l-3-1c-3%200-3%200-3%202%200%203-4%206-5%204l1-1v-2l-3-2c-2-2-2-2-3%200-1%203-3%204-4%203h-5c-2-1-2-1-2%201s-1%202-6%202h-6v-3c0-3%200-3%202-2h3c-1-1%200-1%201-1l2-2-1-1h-7v-24l-1-24c-1-1-1%201-1%203l-1%205-1-1c0-1-5-7-5-5l-4-6c-3-7-3-8-3-20v-12l-55%201c-55%200-56%200-58%202-3%204-3%205%2010%2011%2011%207%2012%207%2011%2010l1%204%201%205a570%20570%200%2000-4%2052l-2%203-1%201-1-1c0-1-1-2-4-2-4%201-5%200-5-1l-2-1c-3%200-3%200-3%203l-3%203c-3%201-3%201-3-1v-2l-1-2c-1-3-2-3-4%201l-4%202-2%201H82c-2%200-3%200-2-2%201-5%201-5%202-4s4%200%204-1l-3-1-3-1v-8c2-21%202-20%205-20s4%200%204-3c0-4-1-5-3-6-3-1-3-2-3-7%200-6-2-5-2%201%200%204-2%204-3%200l-3-3-2-2-2-4c-2-5-3-9-2-19%201-9%201-9-4-8m34%2026c0%203%200%204%2011%208%208%203%2010%203%2010-1l-1-4-10-4c-1%201%202%204%204%205%203%200%202%202-1%202-5-1-13-7-8-7%202%200-1-2-3-2s-2%201-2%203m-12%204v8c2%202%2010%205%2012%204s3-6%201-8c-1-2-12-5-13-4m165%200c-2%206%201%209%209%2011%204%200%205-1%204-5s-11-9-13-6m-149%208c-1%203%201%207%206%208s6%201%206-3-1-5-6-7c-5-1-6-1-6%202m167%200c0%205%203%207%208%207%206%201%206-7%200-9s-8-1-8%202m-154%204c0%204%201%206%206%208s6%201%206-4c0-3%200-3-3-5-6-2-8-1-9%201m134%200v8c3%202%209%202%2010%200s0-6-2-7l-8-1m86%203l-1%204c0%206-1%209-4%2011l-2%201%202%201h3l4-1c3%200%203%201%204%205%200%204%201%206%202%206l3-23c-2-2-11-5-11-4m-159%204c-2%2010-2%2010-5%2011-3%202-3%202-1%203s9%200%209-2h2c4%201%205%201%205-3l2-6-6-4c-6-4-6-4-6%201m-62%204c-2%205%205%2010%208%206%201-1%201-1%202%201%202%203%207%204%208%201%200-4%200-6-4-7-2-1-3-1-4%201-1%201-1%201-1-1-2-3-8-4-9-1m-24%201v7c1%203%208%205%2010%202%202-2%201-5-1-7s-7-3-9-2m217%2021c-5%205-5%206-2%208l1%202v2l-1%203c-2%202%200%204%203%204l2-1v-2c1-1%201-1-1-2l-1-1h1c1%200%202-1%202-3%201-3%203-4%203-2l2%204c2%201%202%201%202-1l-2-4-1-5c1-1-1-4-4-5l-4%203m-156-1l-3%202c-3%202-5%205-3%206%201%201%202%202%201%204l1%203%201%201-1%201v3l3%202c2-1%202-6%201-7l-1-1h2l1-2c0-2%202-4%202-1v2l2%202c2%202%201-11-1-14-2-2-5-3-5-1m8%20121c-2%201-3%203%200%203l1%201-2%201c-3%200-2%204%201%205h9c1%200%202-1%202-3l-1-3h-3l2-1c2%200%202%200%200-3-4-2-6-3-9%200m18%200c-3%202-4%209-1%2010l1-1%201-3c2-1%202-2%202-4l1-2%201%203%202%203%202%201-2%203c-1%203%202%202%203%200%203-3%202-7%200-10-3-3-7-3-10%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/73ff9d5f710b76e5daba660a534cc1e8/ca0a1/techletter.app-screenshot-1554137659460.webp 223w", "/static/73ff9d5f710b76e5daba660a534cc1e8/75680/techletter.app-screenshot-1554137659460.webp 445w", "/static/73ff9d5f710b76e5daba660a534cc1e8/d3be9/techletter.app-screenshot-1554137659460.webp 480w"],
                "sizes": "(max-width: 480px) 100vw, 480px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/73ff9d5f710b76e5daba660a534cc1e8/e92b6/techletter.app-screenshot-1554137659460.png 223w", "/static/73ff9d5f710b76e5daba660a534cc1e8/e66bf/techletter.app-screenshot-1554137659460.png 445w", "/static/73ff9d5f710b76e5daba660a534cc1e8/e85cb/techletter.app-screenshot-1554137659460.png 480w"],
                "sizes": "(max-width: 480px) 100vw, 480px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/73ff9d5f710b76e5daba660a534cc1e8/e85cb/techletter.app-screenshot-1554137659460.png",
                "alt": "https://twitter.com/Swizec/status/1112428230063984640",
                "title": "https://twitter.com/Swizec/status/1112428230063984640",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`https://twitter.com/Swizec/status/1112428230063984640`}</figcaption>{`
  `}</figure></a></p>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/EricVicenti"
      }}>{`Eric Vicenti`}</a>{` told us about a new architecture for webapps that he's working on. No more database talking to many servers, talking to many clients, having errors and wondering about transactions and correctness, oh no.`}</p>
    <p>{`He proposes an architecture based on web sockets, immutable data, and live streaming connections.`}</p>
    <p>{`You use a chain of blocks to ensure your data is correct. You store actions instead of state. You keep the reducer on the backend so it always knows the final state. You make changes with a pair of `}<inlineCode parentName="p">{`(state, action)`}</inlineCode>{` so the server can error you out if your state is wrong.`}</p>
    <p>{`Great idea. Seems to work. He's waiting to finish docs before releasing.`}</p>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/Swizec/status/1112451664047333377"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "480px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "112.10762331838563%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'449\\'%20viewBox=\\'0%200%20400%20449\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M31%2021c-5%203-7%208-7%2014l2%206%201%202c0%201%206%205%2010%205%204%201%209%200%2012-3%201-2%201-2-1-2-4%200-5-3-2-5%201-1%203-2%204-1l1-1%201-2c3%201%201-10-3-11l-3-2c-3-3-10-3-15%200m36%20183c-6%201-7%203-7%2028v22h3l2-1h1c2%203%2020%203%2020%200h1v1l2%201%202-1h1l4%201c6%200%208%201%206%204-2%202-9%206-12%205l-3%202h-1c0-2-1-2-3-1l-3-1v-1l-3-1-3%201h-6l-5%201h-2a715%20715%200%20001%2095l2%203h307l2-3c2-2%202-3%202-76l-1-75c-1-5%205-5-155-5l-152%201m151%2025c0%2013%200%2019-1%2018s-1-1-1%201l-2-3-1-5v5l-2%2011-3%208c-1%203-3%204-9%204l-5%201h4c6%200%208%202%209%207l1%204c1%201%201%201-1%201l5%201%207%201v-37a680%20680%200%2000-1-17m-34%2018c-2%201-3%201-3%208%200%209%201%2015%204%2015%202-1%205-9%205-14%200-2%200-3%203-3s4-1%204-3c0-3%200-3-3-2l-4-1h-6m-44%2010h-5l-4%201h-3l-1%201%202%202c2%200%202%201%202%2010v10h2c2-1%203%200%203%201%200%202%202%203%205%201%202-1%202-13%200-17l-4-3h-3c-1-2%200-2%203-2%204-1%205-2%205-3%200-2%200-2-2-1m-5%2053c0%202%200%202-3%202h-2l2%201%203%201h-3c-2%200-2%200-1%201%203%200%202%202%200%202-4%201-3%202%201%203l13%201-3-1-3-1h4c1%200%202%200%201-1h-2l2-1c1-1%201-1-2-2-3%200-5-5-3-6%201-1%200-1-2-1s-3%200-2%202m59%2089l-2%203c-1%202-1%202-2%201-4-3-5%204-2%207%206%206%2015-1%2012-9-2-4-4-4-6-2m13%200c-4%203-4%208-1%2011%202%202%203%202%203%201%200-2%201-2%203-2v2c0%202%203%201%205-2%206-7-3-16-10-10m18%200c-4%203-4%208-1%2011%207%207%2017-4%2011-11-3-3-7-3-10%200m17%200c-3%204-2%2012%201%2010l1%201c2%205%2011%200%2011-6s-8-9-13-5m38-1c-2%202-4%207-3%207l1%202v2c0%203%205%200%205-4%201-2%203-3%203-1l-3%206c-2%201%202%202%204%202%202-1%205-7%205-9-2-5-9-7-12-5m-108%201l-1%203-1%204c-4%203%202%207%207%206%203-1%205-4%203-5-2-2-1-3%201-2v-1l-2-2h3c0-2-8-5-10-3m90%200v2c1%201%201%201-1%201l-2%201%201%201v1c-2%201-1%204%202%203l1%202c-1%202%207%202%209-1s1-4-2-4c-3%201-3%201-4-3-1-2-1-3%201-3%202-1%201-1-1-1l-4%201m38%200l1%201c2%200%203%200%203%205%200%204%200%204-2%203-1-1-2-3-1-4l-1-3c-1-1-3%207-2%209s6%202%209%200c2-1%203-7%201-10-1-2-8-3-8-1\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/8630857990a1b9cbe5036f92c1ec9108/ca0a1/techletter.app-screenshot-1554137659811.webp 223w", "/static/8630857990a1b9cbe5036f92c1ec9108/75680/techletter.app-screenshot-1554137659811.webp 445w", "/static/8630857990a1b9cbe5036f92c1ec9108/d3be9/techletter.app-screenshot-1554137659811.webp 480w"],
                "sizes": "(max-width: 480px) 100vw, 480px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/8630857990a1b9cbe5036f92c1ec9108/e92b6/techletter.app-screenshot-1554137659811.png 223w", "/static/8630857990a1b9cbe5036f92c1ec9108/e66bf/techletter.app-screenshot-1554137659811.png 445w", "/static/8630857990a1b9cbe5036f92c1ec9108/e85cb/techletter.app-screenshot-1554137659811.png 480w"],
                "sizes": "(max-width: 480px) 100vw, 480px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/8630857990a1b9cbe5036f92c1ec9108/e85cb/techletter.app-screenshot-1554137659811.png",
                "alt": "https://twitter.com/Swizec/status/1112451664047333377",
                "title": "https://twitter.com/Swizec/status/1112451664047333377",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`https://twitter.com/Swizec/status/1112451664047333377`}</figcaption>{`
  `}</figure></a></p>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/emplums"
      }}>{`Emily Plummer`}</a>{` told us all about design systems and how they're used at GitHub.`}</p>
    <p>{`A design system isn't just a set of React components. It's an entire toolset of components, documentation, css, etc that helps engineers ship good looking apps from mockups.`}</p>
    <p>{`Get mockups, refer to the system, produce beautiful UI. Streamlines communication between designers and engineers because you're talking a common language. Means designers don't have to give you time consuming pixel-perfect designs, and you don't have to waste your time building pixel-perfect CSS.`}</p>
    <p>{`Your design system does it for you. ❤️`}</p>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/Swizec/status/1112456945921716224"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "480px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "126.90582959641254%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'508\\'%20viewBox=\\'0%200%20400%20508\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M32%2021c-14%207-8%2028%208%2028l7-2%204-2-4-2c-5-2-4-6%202-6l2-1%201-1c2%202%202-3%201-7-4-7-14-11-21-7m32%20165l-3%202v114c0%20110%200%20115%202%20116%202%202%2014%202%20155%202h154l2-3c2-2%202-3%202-62a349%20349%200%2000-2-67c1-4%201-14-1-14l-4-2h-4l-3%201c-3%200-3%200-3-5%200-7%201-7%209-9l6-2c2-1%203-13%201-14v-2c1%200%201-50-1-53l-2-3-154-1H66l-2%202m306%2029c-2%201-3%206-5%2014l-3%207c-2%202-2%202-1%203l1%207c-1%206%200%207%204%205%201-2%202-3%201-4l1-2%201-3c0-2%201-2%202-2%202%200%202-4%201-7v-7c2-11%202-13%201-13l-3%202m-64%2037l-1%202-2-1c0-2%200-2-6-1-4%201-7%203-4%203l1%204c0%202%200%203%202%203l1-4c0-3%200-4%202-4l1%204c0%202%200%203%202%203l1-2%202-2%201%202%202%201%201-5c0-4-3-7-3-3m-34%206l-1%202c0%202%200%202-1%201-3-4-8-1-8%204%201%203%204%204%206%201%201-2%201-2%203%200%201%201%201%201%202-1s1-2%202-1c2%203%203%202%203-2-1-5-2-6-6-4m77%205c-5%201-7%202-8%204l-4%204-8%207-7%2017-2%206c-3%201%202%2023%205%2025l1%203c0%202%201%202%2013%202h13v-8l1-22c0-13%200-13%202-15s2-2%201-12c0-12%200-12-7-11m-73%208c-2%201-3%207-1%209l5%202c4%200%204%200%205-2%203-6-3-12-9-9m-141%2014c-3%201-5%202-4%203%200%202-14%201-15%200l-1-2-1%202-5%201c-5%200-6%200-6%202%201%208%208%2010%2019%206%206-2%207-2%207%200%201%202%203%204%203%202l2-2%201%202%202%202%201-1%202-1%201%201c-1%201%200%202%203%201l13-2%201-1c1%201%208-4%208-6%200-1-1-2-6-2l-6-2c-1-2-3-3-3-1%201%201-1%202-9%202-9%200-9-2%200-2l3-1c0-2-2-2-10-1m-5%2020l-1%202-1%202v7l1%201%201-2%203%202h1l2-2c2%200%204-2%202-2l-1-2c1-1%202-1%203%201h1l-1-3-1-2c0-2-8-4-9-2m87%20152h-2c-3-1-4%2010-2%2012%205%204%2013%201%2013-5l-2-4-1%202v3l-1-4c-1-5-4-7-5-4m14%202c-2%203-2%204-1%207%204%207%2011%207%2014%200%204-7-8-14-13-7m-72%200c-3%202-2%208%201%2010%203%203%207%203%2010-1%202-2%203-7%200-6l-2-2h-1l-2-1c0-2-5-2-6%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/68d60db8ae64b31aaa22259cf849dc22/ca0a1/techletter.app-screenshot-1554137659956.webp 223w", "/static/68d60db8ae64b31aaa22259cf849dc22/75680/techletter.app-screenshot-1554137659956.webp 445w", "/static/68d60db8ae64b31aaa22259cf849dc22/d3be9/techletter.app-screenshot-1554137659956.webp 480w"],
                "sizes": "(max-width: 480px) 100vw, 480px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/68d60db8ae64b31aaa22259cf849dc22/e92b6/techletter.app-screenshot-1554137659956.png 223w", "/static/68d60db8ae64b31aaa22259cf849dc22/e66bf/techletter.app-screenshot-1554137659956.png 445w", "/static/68d60db8ae64b31aaa22259cf849dc22/e85cb/techletter.app-screenshot-1554137659956.png 480w"],
                "sizes": "(max-width: 480px) 100vw, 480px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/68d60db8ae64b31aaa22259cf849dc22/e85cb/techletter.app-screenshot-1554137659956.png",
                "alt": "https://twitter.com/Swizec/status/1112456945921716224",
                "title": "https://twitter.com/Swizec/status/1112456945921716224",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`https://twitter.com/Swizec/status/1112456945921716224`}</figcaption>{`
  `}</figure></a></p>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/jtomchak"
      }}>{`Jesse Tomchak`}</a>{` got everyone excited about Babel macros. It's like writing code that writes your code and it's really powerful.`}</p>
    <p>{`For example, you can write a language extension that replaces something like `}<inlineCode parentName="p">{`?.`}</inlineCode>{` into a series of null-safety checks. Means you don't have to worry about writing your own checks which are almost always wrong. 👌`}</p>
    <p>{`Oh and you can speed up your code by doing things at compile time instead of run time. That's what macros are for. Want to statically insert some code in a bunch of places? Write a macro.`}</p>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/Swizec/status/1112462651416694785"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "480px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "137.21973094170403%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'549\\'%20viewBox=\\'0%200%20400%20549\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M32%2020c-2%201-7%207-8%2010l2%2011%201%201c0%202%206%206%2010%207%203%200%205%200%208-2%206-2%206-4%202-4-3%200-4-3-1-5l3-1%203-2c2-2%202-2%201-6-2-8-13-12-21-9m31%2042c-3%203-2%207%200%209%204%204%209%202%2010-4s-7-10-10-5m0%2084c-2%202-2%203-2%2023l1%2020a698%20698%200%200061-11%209028%209028%200%200057-10l-4%2064a30895%2030895%200%2000-7%20151l-61%201H61v37c0%2034%200%2037%202%2038a140467%20140467%200%2000311%200c2-2%202-3%202-139l-1-139c0-4-1-4-18-4s-26-2-22-5c4-2%2031-4%2033-2h4l4-1v-10c0-9%200-10-2-12l-2-3H218c-152%200-153%200-155%202m201%2031a27594%2027594%200%2000-5%20179v27h5v-19a13210%2013210%200%20003-212h-3v25M108%20499c-3%204-3%208%200%2011%207%207%2017-4%2011-11l-5-2-6%202m21-1c-6%204-5%2014%202%2014%205%200%209-5%208-10-1-2-3-1-3%202-1%202-1%201-1-2%200-5-2-6-6-4\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/d1cdeb901dbbd8105b849a9e1e9f6094/ca0a1/techletter.app-screenshot-1554137659720.webp 223w", "/static/d1cdeb901dbbd8105b849a9e1e9f6094/75680/techletter.app-screenshot-1554137659720.webp 445w", "/static/d1cdeb901dbbd8105b849a9e1e9f6094/d3be9/techletter.app-screenshot-1554137659720.webp 480w"],
                "sizes": "(max-width: 480px) 100vw, 480px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/d1cdeb901dbbd8105b849a9e1e9f6094/e92b6/techletter.app-screenshot-1554137659720.png 223w", "/static/d1cdeb901dbbd8105b849a9e1e9f6094/e66bf/techletter.app-screenshot-1554137659720.png 445w", "/static/d1cdeb901dbbd8105b849a9e1e9f6094/e85cb/techletter.app-screenshot-1554137659720.png 480w"],
                "sizes": "(max-width: 480px) 100vw, 480px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/d1cdeb901dbbd8105b849a9e1e9f6094/e85cb/techletter.app-screenshot-1554137659720.png",
                "alt": "https://twitter.com/Swizec/status/1112462651416694785",
                "title": "https://twitter.com/Swizec/status/1112462651416694785",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`https://twitter.com/Swizec/status/1112462651416694785`}</figcaption>{`
  `}</figure></a></p>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/CodeAthena"
      }}>{`Zach Gotsch`}</a>{` showed us a great new form library he's been building, called formula-one.`}</p>
    <p>{`Formula-one is all about writing type-safe forms. This is important because with React you build custom form elements. Those go way beyond text and textarea so it's time to think about proper typing.`}</p>
    <p>{`Wouldn't want your server to get a string when it expects an array of objects would you? Of course not.`}</p>
    <p>{`Since typing isn't be all and end all, you still nee validation, formula-one makes that easier too. Looked neat, gonna have to try it.`}</p>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/Swizec/status/1112476828604592128"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "480px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "121.97309417040358%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'488\\'%20viewBox=\\'0%200%20400%20488\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M32%2021c-6%203-8%207-8%2014l2%206%201%201c0%202%205%206%209%207%204%200%209-1%2012-3l3-2-4-1c-5-1-4-6%202-6l2-2h1c2%201%202-3%201-6-3-8-14-12-21-8m32%20145l-3%202v37h4c5%200%205%200%205%204l1%207c-1%203-1%203-6%202h-4v89c0%2086%200%2090%202%2091%202%202%2014%202%20155%202h154l2-3c2-2%202-2%202-113%200-114%200-117-4-118l-154-1-152-1-2%202m123%2044h-6c-4%200-4%200-4%202l-3%2078c-1%2010%201%2011%2011%2012h8l23%203c30%203%2032%203%2032%205l-1%201-2%202c0%202%2014%203%2071%204h39l-1-9a11143%2011143%200%2001-9-84%201332%201332%200%2000-158-14m-62%2021c-2%202-2%202-9%201l-9-1v4l1%202h2l3%202%201%201c-2%200%201%201%205%203l7%202%203-1c4%200%207-1%207-3l1-1h2l-4-2c-7-3-9-4-7-7%201-3-1-3-3%200m-47%2022l-1%204c0%202-1%203-4%204-5%202-5%205-1%208%203%202%203%203%203%207l1%204v-2c-1-3%201-6%203-5%205%201%206%204%203%206h1l5-2%204-2c3%200%204%201%202%204v3l2-5c0-2%201-3%203-4%205-1%205-4%201-7-2-2-2-3-2-6%200-4-1-5-3-5l-5%201c-1%201-2%200-4-2-3-2-6-3-8-1m4%2011c-3%204%200%209%205%209%206%200%207-9%202-10-4-1-4-1-7%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/2597cb35e90af2233a103ebf325ed7ea/ca0a1/techletter.app-screenshot-1554137659783.webp 223w", "/static/2597cb35e90af2233a103ebf325ed7ea/75680/techletter.app-screenshot-1554137659783.webp 445w", "/static/2597cb35e90af2233a103ebf325ed7ea/d3be9/techletter.app-screenshot-1554137659783.webp 480w"],
                "sizes": "(max-width: 480px) 100vw, 480px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/2597cb35e90af2233a103ebf325ed7ea/e92b6/techletter.app-screenshot-1554137659783.png 223w", "/static/2597cb35e90af2233a103ebf325ed7ea/e66bf/techletter.app-screenshot-1554137659783.png 445w", "/static/2597cb35e90af2233a103ebf325ed7ea/e85cb/techletter.app-screenshot-1554137659783.png 480w"],
                "sizes": "(max-width: 480px) 100vw, 480px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/2597cb35e90af2233a103ebf325ed7ea/e85cb/techletter.app-screenshot-1554137659783.png",
                "alt": "https://twitter.com/Swizec/status/1112476828604592128",
                "title": "https://twitter.com/Swizec/status/1112476828604592128",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`https://twitter.com/Swizec/status/1112476828604592128`}</figcaption>{`
  `}</figure></a></p>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/gurlcode"
      }}>{`Jenn Creighton`}</a>{` called herself a React detective and taught us something important about React that we all managed to forget or not realize. She learned it through investigating tweets from the core team.`}</p>
    <p>{`Did you know React Fiber, the reconciler React's been using since 2016 or so, isn't even a Virtual DOM anymore?`}</p>
    <p>{`That's right. React does not in fact use a virtual dom. It uses a virtual call stack. Mind, blown. 🤯`}</p>
    <p>{`Most of her talk went right over my head. I'd have to sit down and study what she said for a few hours to understand `}<em parentName="p">{`how`}</em>{` Fiber works. It's mindbendy and computer sciencey and exercises brain muscles I haven't used in years.`}</p>
    <p>{`Bottom line is this: No more VDOM. Virtual Stack instead. This enables asynchronous updates and `}<em parentName="p">{`eventually`}</em>{` is going to give us React Suspense.`}</p>
    <p>{`Can't wait`}</p>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/Swizec/status/1112485359714099200"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "480px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "121.97309417040358%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'488\\'%20viewBox=\\'0%200%20400%20488\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M32%2021c-6%203-8%207-8%2014l2%206%201%202%202%202c2%201%202%201%201-1%200-3%200-3%204-2%205%200%209-2%206-4l1-1c4-1%203-1%201%204-3%205-4%206-8%206h-3c2%203%2013%202%2017-1l3-2-4-1c-5-1-4-6%202-6l2-2%201-1c2%202%202-1%201-5-3-8-13-12-21-8m32%20145l-3%202v84l2-4c3-4%204-4%204%201%200%204-1%205-2%203-1-3-4%201-4%205s0%204%203%204c4%200%205%202%205%206-1%203%200%204%202%206%204%203%204%206-1%208-3%200-4%201-4%204-1%204-2%205-4%205s-2%20106%201%20108c2%202%2014%202%20155%202h154l2-3c2-2%202-3%202-43a223%20223%200%2000-1-43l1-8c0-7%200-7-3-7h-5c-2%201-4%200-4-3l2-2v1l2%201%205-1c2%200%203-1%202-3%200-1-1-2-4-2l-4-1h8v-4c0-4%200-5-2-4s-13-2-14-4h-2l-1-2c0-2%201-2%206-2s8-2%208-4l1-1%201%202c0%201%200%202%202%202h2V169l-2-3-3-2H66l-2%202m116%2054l2%203v4c-2%200-3%202-3%206%200%202%200%202-1%201l-2%2020v21l4-1c6%200%208%201%208%209l-1%209-1%205c1%201%200%202-2%204-4%204-4%204-4%201l-1-3-2-5c0-5-2-6-2-2-1%203-1%203-8%205l-4%203-1%204c-1%202%200%203%2024%205a1242%201242%200%200135%205l-1%202c-1%200-2%201-2%203v3h17l49%201c39%200%2036%202%2036-20l1-17c2%200%201-8-1-10l-9-1-7%201-1-4-2-8-1-5-2-7-2-9-3-5-4-5-2-1a757%20757%200%2000-82-9c4%200%203%203-1%204h-6c-2%201-3%200-4-3l-3-4h-3l-4-2c-4%200-4%200-4%202M71%20235c-4%204%201%2011%2012%2016l8%204%203%201h2c1%202%202%202%203%201h2c0%202%201%202%202%201h1c0%201%209-2%2011-4l2-4%201-2-7-4c-10-3-10-3-9-7%202-3-2-2-4%201l-2%202-10-3c-13-3-13-4-15-2\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/d5d59cddf9e4bfbda5b533d1dad6c42f/ca0a1/techletter.app-screenshot-1554137659676.webp 223w", "/static/d5d59cddf9e4bfbda5b533d1dad6c42f/75680/techletter.app-screenshot-1554137659676.webp 445w", "/static/d5d59cddf9e4bfbda5b533d1dad6c42f/d3be9/techletter.app-screenshot-1554137659676.webp 480w"],
                "sizes": "(max-width: 480px) 100vw, 480px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/d5d59cddf9e4bfbda5b533d1dad6c42f/e92b6/techletter.app-screenshot-1554137659676.png 223w", "/static/d5d59cddf9e4bfbda5b533d1dad6c42f/e66bf/techletter.app-screenshot-1554137659676.png 445w", "/static/d5d59cddf9e4bfbda5b533d1dad6c42f/e85cb/techletter.app-screenshot-1554137659676.png 480w"],
                "sizes": "(max-width: 480px) 100vw, 480px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/d5d59cddf9e4bfbda5b533d1dad6c42f/e85cb/techletter.app-screenshot-1554137659676.png",
                "alt": "https://twitter.com/Swizec/status/1112485359714099200",
                "title": "https://twitter.com/Swizec/status/1112485359714099200",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`https://twitter.com/Swizec/status/1112485359714099200`}</figcaption>{`
  `}</figure></a></p>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/leeb"
      }}>{`Lee Byron`}</a>{` then traveled us through time. It was 1999 and /cgi-bin/ is all the rage. You can build `}<em parentName="p">{`dynamic`}</em>{` websites. Wow.`}</p>
    <p>{`His talk was amazing, beautiful, and a great performance. Such a great summary of itself that I can't even give you a summary. 😅`}</p>
    <p>{`Lee basically talked about how React grew out of a PHP-based component framework for server-side dynamic web applications and how the modern React Hooks approach is like going back full circle.`}</p>
    <p>{`You have a component with a bit of markup and a few function calls to other stuff. Just like PHP templates 20 years ago.`}</p>
    <p>{`Brilliant.`}</p>
    <p>{`Just the insight of how React came to be was worth it. Guess that's what happens when you work at Facebook for 10 years and see the evolution first hand.`}</p>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/Swizec/status/1112497539163410433"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "480px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "111.6591928251121%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'448\\'%20viewBox=\\'0%200%20400%20448\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M32%2021c-6%203-8%208-8%2014l2%206%201%202%202%202c1%200%201-2-1-6%200-2%200-2%202-2%203%200%204%201%202%203-2%201%200%202%203%202s6-2%205-4l1-1c4-1%203-1%201%204-3%205-4%206-8%206h-3c2%203%2013%202%2017-1l3-2-4-1c-5-1-4-6%202-6l2-1%202-2c3%200-1-9-5-11l-3-2c-3-3-9-3-13%200m291%20104v17c1%2014%201%2043-1%2044l-1-1c-2-2-3-1-5%202-2%202-2%203-3%202h-1l-2%202v6c-1%200-2%201-2%203l1%202c1%200%202%201%201%202h-3a3861%203861%200%2001-241-8c2-2%201-2-2-1-2%201-2%201-2-1a3503%203503%200%20001%20164c2%202%203%202%20155%202h154l2-3c2-2%202-2%202-107l-1-113c-1-13%201-12-27-13l-25%201M72%20173h-2c-2%200-3%200-4%202h-1c0-3-2-2-2%201%200%202%200%202-1%201-1-2-1%200-1%206%200%208%200%209%203%207v-3c-1-1-1-1%201-1%203%201%205%200%203-1s-1-4%201-4l2-2c0-2%201-3%202-3%201-1%202-4%200-4l-1%201m30%2073c-2%201-2%202-3%208l-1%204c-1%202-1%202%203%202%205-1%205%200%200%202l-3%202h2l4-1%206-4c2-2%203-3%204-1l1%202v4c2%200%203-2%202-3v-3c2-1%202-1%203%201h4c3-1%203-1%205%201%201%202%202%202%202%201v-3c-2-2-2-2%200-3s2-1%201-2c-2-1-5%200-5%201h-2c-1-1-1-1-1%201v2l-2-2-2-2-3-1-1%201c1%201%200%202-3%202s-3-1-3-3l-1-6h-7m6%20152c-4%205-1%2013%206%2013%203%200%207-4%207-8%200-6-8-9-13-5m39-1c-2%200-5%205-4%208%200%203%205%206%207%206%206%200%209-10%204-11l-3-2-4-1m20%200c2%201%201%206-1%207-2%200-3-4-1-6v-1c-4%200-5%208-1%2011%202%203%205%204%208%201%202-1%202-1%200-2-1-2-1-5%201-3v1l1%201c2%200%201-6-1-8l-5-2c-2%200-2%200-1%201m-35%202l-4%202c-5%200-5%204-1%207%206%205%2013%201%2012-5-1-5-5-8-7-4\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/f55f7dff787619e2392d44da70b49f86/ca0a1/techletter.app-screenshot-1554137660001.webp 223w", "/static/f55f7dff787619e2392d44da70b49f86/75680/techletter.app-screenshot-1554137660001.webp 445w", "/static/f55f7dff787619e2392d44da70b49f86/d3be9/techletter.app-screenshot-1554137660001.webp 480w"],
                "sizes": "(max-width: 480px) 100vw, 480px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/f55f7dff787619e2392d44da70b49f86/e92b6/techletter.app-screenshot-1554137660001.png 223w", "/static/f55f7dff787619e2392d44da70b49f86/e66bf/techletter.app-screenshot-1554137660001.png 445w", "/static/f55f7dff787619e2392d44da70b49f86/e85cb/techletter.app-screenshot-1554137660001.png 480w"],
                "sizes": "(max-width: 480px) 100vw, 480px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/f55f7dff787619e2392d44da70b49f86/e85cb/techletter.app-screenshot-1554137660001.png",
                "alt": "https://twitter.com/Swizec/status/1112497539163410433",
                "title": "https://twitter.com/Swizec/status/1112497539163410433",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`https://twitter.com/Swizec/status/1112497539163410433`}</figcaption>{`
  `}</figure></a></p>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/wesbos"
      }}>{`Wes Bos`}</a>{` and `}<a parentName="p" {...{
        "href": "https://twitter.com/stolinski"
      }}>{`Scott Tolinski`}</a>{` closed up Reactathon with a live recording of SyntaxFm.`}</p>
    <p>{`Very fun to watch, super entertaining. We learned a bit about hooks, we watched them tag team a small app in 5 minutes.`}</p>
    <p>{`👌`}</p>
    <p>{`Enjoy your Monday`}</p>
    <p>{`❤️, ~Swizec`}</p>
    <p>{`PS: there's no better way to relax before a conference than `}<a parentName="p" {...{
        "href": "https://www.instagram.com/p/BvprE_AluFE/"
      }}>{`riding too fast on a curvy road, farting proudly, and cowboy poetry`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      